import AppBar from '@mui/material/AppBar';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { observer } from 'mobx-react';
import React, { Component } from 'react';
import mainStore from '../../../MainStore';
import authStore from '../../Auth/AuthStore';
import File from '../File/File';
import History from '../History/History';
import LinkBoard from '../Link/LinkBoard';
import AccountSelect from '../Projects/AccountSelect';
import ProjectSelect from '../Projects/ProjectSelect';
import ProjectTypeSelect from '../Projects/ProjectTypeSelect';
import UserSelect from '../Users/UserSelect';
import InvoiceCommentBlock from './InvoiceCommentBlock';
import SaleResultSelect from './SaleResultSelect';
import SaleStore from './SaleStore';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import SaleWorks from './SaleWorks';

const InvoiceDialog = observer(class InvoiceDialog extends Component {
    constructor(props) {
        super(props);
        this.handleTabChange = this.handleTabChange.bind(this);
        this.handleRowCheckedChange = this.handleRowCheckedChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleProjectTypeChange = this.handleProjectTypeChange.bind(this);
        this.handleAccountChange = this.handleAccountChange.bind(this);
        this.handleResultSelectChange = this.handleResultSelectChange.bind(this);
        this.handleProjectSelectChange = this.handleProjectSelectChange.bind(this);
        this.closeSaleClick = this.closeSaleClick.bind(this);
        this.handleMenuClick = this.handleMenuClick.bind(this);
        this.handleMenuClose = this.handleMenuClose.bind(this);
        this.handleDeleteInvoice = this.handleDeleteInvoice.bind(this);

        this.state = {
            fullscreen: false
        };
    }

    componentDidUpdate() {
        console.log(arguments);
    }

    handleClose() {
        SaleStore.closeInvoiceDialog();
    }

    handleMenuClick(evt) {
        this.setState({ anchorEl: evt.currentTarget, isMenuOpen: true });
    }

    handleMenuClose() {
        this.setState({ anchorEl: null, isMenuOpen: false });
    }

    handleTabChange(event, newValue) {
        SaleStore.setSelectedTab(newValue);
    }

    handleRowCheckedChange = name => evt => {
        var sale = SaleStore.getInvoice;
        sale[name] = evt.target.checked;
        SaleStore.setInvoice(sale);
    }

    handleRowDataChange = name => evt => {
        var sale = SaleStore.getInvoice;
        sale[name] = evt.target.value;
        SaleStore.setInvoice(sale);
    }

    closeSaleClick() {
        SaleStore.openSaleFinishDialog(SaleStore.getInvoice.id, !!SaleStore.getInvoice.project);
    }

    handleSave() {
        var scope = this;
        mainStore.setMaskVisible();
        var token = localStorage.getItem("token");
        fetch('api/Sale/Add', {
            method: 'POST',
            body: JSON.stringify(SaleStore.getInvoice),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                authStore.openLogin();
                mainStore.setMaskUnvisible();
                //scope.startSearch(); Перезагрузить доску?
            }
            else {
                res.json().then((result) => {
                    if (scope.props.onSaleUpdate) {
                        scope.props.onSaleUpdate(result);
                    }

                    mainStore.setMaskUnvisible();
                    SaleStore.closeSaleDialog();
                }).catch((err) => console.log(err));
            }
        });
    }

    handleResultSelectChange(result) {
        var sale = SaleStore.getInvoice;
        sale.resultId = !!result ? result.id : '';
        sale.result = !!result ? result.name : '';
        SaleStore.setInvoice(sale);
    }

    handleProjectSelectChange(project) {
        var sale = SaleStore.getInvoice;
        sale.projectId = !!project ? project.id : '';
        sale.project = !!project ? project.name : '';
        SaleStore.setInvoice(sale);
    }

    handleProjectTypeChange(projectType) {
        var sale = SaleStore.getInvoice;
        sale.projectTypeId = projectType.id;
        sale.projectTypeName = projectType.name;
        sale.projectTypeColor = projectType.color;
        SaleStore.setInvoice(sale);
    }

    handleAssigneeChange(user) {
        var sale = SaleStore.getInvoice;
        sale.ownerId = !!user ? user.id : '';
        sale.owner = !!user ? user.name : '';
        SaleStore.setInvoice(sale);
    }

    handleAccountChange(account) {
        var sale = SaleStore.getInvoice;
        sale.accountId = !!account ? account.id : '';
        sale.account = !!account ? account.name : '';
        SaleStore.setInvoice(sale);
    }

    handleTesterChange(user) {
        var sale = SaleStore.getInvoice;
        sale.controllerId = user.id;
        sale.controller = user.name;
        SaleStore.setInvoice(sale);
    }

    handleDeleteInvoice() {
        const conf = window.confirm("Ты уверен что точно хочешь прямо удалить эту задачу? Потом вернуть ее будет возможно!");
        if (conf) {
            var scope = this;
            mainStore.setMaskVisible();
            var token = localStorage.getItem("token");
            fetch('api/Invoice/Delete', {
                method: 'POST',
                body: JSON.stringify(SaleStore.getInvoice.id),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (res) {
                if (res.status === 401) {
                    authStore.openLogin();
                    mainStore.setMaskUnvisible();
                    //scope.startSearch(); Перезагрузить доску?
                }
                else {
                    res.json().then((result) => {
                        if (scope.props.onInvoiceUpdate) {
                            scope.props.onInvoiceUpdate(SaleStore.getInvoice, true);
                        }

                        mainStore.setMaskUnvisible();
                        SaleStore.closeInvoiceDialog();
                    }).catch((err) => console.log(err));
                }
            });
        }
    }

    formatDate(d) {
        var date = new Date(d);
        var month = (date.getMonth() + 1);
        if (month < 10) month = '0' + month;

        var day = date.getDate();
        if (day < 10) day = '0' + day;

        return date.getFullYear() + '-' + month + '-' + day;
    }

    render() {
        return (
            <Dialog
                onClose={this.handleClose}
                aria-labelledby="customized-dialog-title"
                open={SaleStore.isInvoiceOpen}
                maxWidth="md"
                fullWidth
                fullScreen={this.state.fullscreen}
                className={"invoice-dialog " + (this.state.fullscreen ? "fullscreen" : "")}
            >
                <DialogTitle id="customized-dialog-title" onClose={this.handleClose}>
                    Счет {SaleStore.getInvoice.number}
                    <FormControlLabel
                        control={
                            <Checkbox checked={SaleStore.getInvoice.isFlagged} onChange={this.handleRowCheckedChange('isFlagged')} value="true" />
                        }
                        label="Флаг"
                    />
                    <a href={SaleStore.getInvoice.crmLink} target="_blank" rel="noopener noreferrer">CRM</a>
                </DialogTitle>
                <DialogContent dividers>
                    <AppBar position="static" color="default" className="short-appbar">
                        <Tabs
                            value={SaleStore.getSelectedTab}
                            onChange={this.handleTabChange}
                            indicatorColor="primary"
                            textColor="primary"
                            variant="scrollable"
                            scrollButtons="auto"
                        >
                            <Tab label="Главная" />
                            <Tab label="История" />
                            <Tab label="Вложения" />
                            <Tab label="Связи" />
                            <Tab label="Задачи" />
                        </Tabs>
                    </AppBar>
                    <div className="action-button-block">
                        <IconButton
                            aria-label="more"
                            aria-controls="long-menu"
                            aria-haspopup="true"
                            onClick={this.handleMenuClick}
                            size="large">
                            <MoreVertIcon />
                        </IconButton>
                        <Menu
                            id="long-menu"
                            anchorEl={this.state.anchorEl}
                            keepMounted
                            open={this.state.isMenuOpen}
                            onClose={this.handleMenuClose}
                            PaperProps={{
                                style: {
                                    maxHeight: 200,
                                    width: 200,
                                },
                            }}
                        >
                            <MenuItem key={0} onClick={this.handleDeleteInvoice}>
                                Удалить
                            </MenuItem>
                        </Menu>
                        {!this.state.fullscreen && <IconButton onClick={() => { this.setState({ 'fullscreen': true }); }} size="large">
                            <FullscreenIcon />
                        </IconButton>
                        }
                        {this.state.fullscreen && <IconButton onClick={() => { this.setState({ 'fullscreen': false }); }} size="large">
                            <FullscreenExitIcon />
                        </IconButton>
                        }
                    </div>
                    {SaleStore.getSelectedTab === 0 && <div className="card-inner-block">
                        <Typography component={'span'}>
                            <TextField required
                                id="standard-required"
                                label="Заголовок"
                                fullWidth
                                margin="normal"
                                value={SaleStore.getInvoice.caption}
                                onChange={this.handleRowDataChange('caption')}
                            />
                        </Typography>
                        <Typography component={'span'}>
                            <TextField required
                                id="standard-required"
                                label="Прибыль, руб"
                                fullWidth
                                margin="normal"
                                type="number"
                                value={SaleStore.getInvoice.profit}
                                onChange={this.handleRowDataChange('profit')}
                            />
                        </Typography>
                        <Typography component={'span'}>
                            <div className="half-block">
                                <AccountSelect name={SaleStore.getInvoice.account} label="Контрагент" handleSelect={this.handleAccountChange} />
                            </div>
                            <div className="half-block">
                                <ProjectTypeSelect name={SaleStore.getInvoice.projectTypeName} label="Тип проекта" handleSelect={this.handleProjectTypeChange} />
                            </div>
                        </Typography>
                        <Typography component={'span'}>
                            <div className="half-block">
                                <UserSelect name={SaleStore.getInvoice.owner} label="Ответственный" handleSelect={this.handleAssigneeChange} />
                            </div>
                            <div className="half-block">
                                <UserSelect name={SaleStore.getInvoice.controller} label="Контроллер" handleSelect={this.handleTesterChange} />
                            </div>
                        </Typography>
                        <Typography component={'span'}>
                            <div className="half-block">
                                <TextField required
                                    id="standard-required"
                                    label="Дата"
                                    fullWidth
                                    margin="normal"
                                    type="date"
                                    value={this.formatDate(SaleStore.getInvoice.date)}
                                    onChange={this.handleRowDataChange('date')}
                                />
                            </div>
                            <div className="half-block">
                                <TextField required
                                    id="standard-required"
                                    label="Стоппер до"
                                    fullWidth
                                    margin="normal"
                                    type="date"
                                    value={this.formatDate(SaleStore.getInvoice.delayTo)}
                                    onChange={this.handleRowDataChange('delayTo')}
                                />
                            </div>
                        </Typography>
                        <Typography component={'span'}>
                            <FormControl>
                                <InputLabel htmlFor="priority-select">Приоритет</InputLabel>
                                <Select
                                    value={SaleStore.getInvoice.priorityId}
                                    onChange={this.handleRowDataChange('priorityId')}
                                    input={<Input name="priority-select" id="priority-select" />}
                                >
                                    <MenuItem value="e025b304-80eb-4870-94e9-d0512984595b">Высочайший</MenuItem>
                                    <MenuItem value="a2c913e8-8505-4d62-830c-f8c6b76e65e5">Высокий</MenuItem>
                                    <MenuItem value="03d3011c-7afe-4c9e-aeee-9ec56323a1e1">Средний</MenuItem>
                                    <MenuItem value="d70acf59-b060-40b3-9aa5-7d6e7adbeb94">Низкий</MenuItem>
                                    <MenuItem value="dba44be7-64be-4e03-99d1-d20b1c9bd13c">Нижайший</MenuItem>
                                    <MenuItem value="a9ae204e-085a-4898-ba85-28baa775b98d">Не делать</MenuItem>
                                </Select>
                            </FormControl>
                        </Typography>
                        <Typography component={'span'}>
                            <TextField required
                                id="standard-required"
                                label="План. часов"
                                fullWidth
                                type="number"
                                margin="normal"
                                value={SaleStore.getInvoice.planHour}
                                onChange={this.handleRowDataChange('planHour')}
                            />
                        </Typography>
                        {SaleStore.getInvoice.statusId === 'e694b03b-c67c-4ef0-b016-fc2ee218b7e3' &&
                            <Typography>
                                <SaleResultSelect name={SaleStore.getInvoice.result} label="Результат" handleSelect={this.handleResultSelectChange} />
                                <ProjectSelect name={SaleStore.getInvoice.project} label="Проект" handleSelect={this.handleProjectSelectChange} />
                                <Button color="secondary" onClick={this.closeSaleClick}>Завершить продажу</Button>
                            </Typography>
                        }
                        <Typography component={'span'}>
                            <TextField required
                                id="standard-required"
                                label="Описание"
                                fullWidth
                                margin="normal"
                                value={SaleStore.getInvoice.description}
                                multiline
                                onChange={this.handleRowDataChange('description')}
                            />
                        </Typography>
                        <Accordion TransitionProps={{ unmountOnExit: true }}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>Комментарии</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <InvoiceCommentBlock invoiceId={SaleStore.getInvoice.id} />
                            </AccordionDetails>
                        </Accordion>
                    </div>}
                    {SaleStore.getSelectedTab === 1 && <div className="card-inner-block"><History saleId={SaleStore.getInvoice.id} /></div>}
                    {SaleStore.getSelectedTab === 2 && <div className="card-inner-block"><File saleId={SaleStore.getInvoice.id} /></div>}
                    {SaleStore.getSelectedTab === 3 && <div className="card-inner-block"><LinkBoard saleId={SaleStore.getInvoice.id} /></div>}
                    {SaleStore.getSelectedTab === 4 && <div className="card-inner-block"><SaleWorks saleId={SaleStore.getInvoice.id} saleNumber={SaleStore.getInvoice.number + " " + SaleStore.getInvoice.caption} isInvoice={true}/></div>}
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleSave} color="primary">
                        Сохранить
                     </Button>
                </DialogActions>
            </Dialog>
        );
    }
});

export default InvoiceDialog;